import { chipColorMap } from '../../../../ui/features/mission-details/components/utils';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { getMissionStatusLabel } from '../../../../ui/utils/getMissionStatusLabel';
import { ChipLight } from '@juvare/common-web-ui/ChipLight';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { Box, Button, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { useMissionTab } from '../../mission/hooks/useMissionTab';
import { MissionContactPlaceholders } from './MissionContactPlaceholders';
export const MissionHeaderContent = (props) => {
    const { missionName, missionStatus, missionDescription, contactName, contactPhone, contactEmail, allowMissionChange } = props;
    const navigate = useNavigate();
    const { t } = useMissionsTranslation();
    const { missionTab } = useMissionTab();
    const handleEditMission = () => {
        navigate('edit');
    };
    const handleBackToMissionList = () => {
        navigate(`/missions?missionTab=${missionTab}`);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                px: { xs: 2, sm: 4 },
                py: { xs: 3, sm: 4 },
                rowGap: 2,
            } },
            React.createElement(Box, { sx: { width: '100%', display: 'flex', justifyContent: 'space-between' } },
                React.createElement(Button, { variant: 'text', color: 'inherit', startIcon: React.createElement(ArrowBackIcon, null), onClick: handleBackToMissionList }, t('missions.backToMissions')),
                missionStatus !== 'closed' && allowMissionChange && (React.createElement(IconButton, { "aria-label": t('missions.editMission'), sx: { color: themeColors.icon.inverse }, onClick: handleEditMission },
                    React.createElement(DriveFileRenameOutlineOutlinedIcon, null)))),
            React.createElement(Box, { sx: { display: 'flex', gap: 3, flexDirection: { xs: 'column', md: 'row' } } },
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, flexBasis: { md: '67%', lg: '75%' } } },
                    React.createElement(Box, { sx: { display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 1 } },
                        React.createElement(Typography, { variant: 'h4', "data-test": 'mission-details-title' },
                            missionName,
                            missionStatus && (React.createElement(ChipLight, { sx: { ml: 1 }, size: 'small', label: getMissionStatusLabel(t, missionStatus, allowMissionChange), color: chipColorMap[missionStatus] })))),
                    React.createElement(Typography, { sx: { typography: { xs: 'body2', md: 'body1' } }, "data-test": 'mission-details-description' }, missionDescription)),
                React.createElement(Box, { sx: {
                        height: '100%',
                        width: '100%',
                        flexBasis: { xs: '100%', md: '33%', lg: '25%' },
                        alignSelf: 'flex-start',
                    } },
                    React.createElement(MissionContactPlaceholders, { contactName: contactName, contactPhone: contactPhone, contactEmail: contactEmail }))))));
};
